import styled from "styled-components";

// #region STYLES
const SmallTagStyled = styled.div`
    &.frame-313374,
    &.frame-313374 * {
        box-sizing: border-box;
    }
    &.frame-313374 {
        border-radius: 2px;
        padding: 3px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: center;
        flex-shrink: 0;
        position: relative;
        height: 15px;
        align-self: center;
    }
    .statuses {
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .alert-text {
        color: ${props =>
            props.enabled ? "var(--text-icons-gray-100, #d1d1d1)" : "var(--text-icons-gray-300, #4f5b6d)"};
        text-align: left;
        font-size: 11px;
        font-weight: 400;
        position: relative;
    }
`;
// #endregion

/**
 * Renders a simple small tag component.
 *
 * @param {Object} props - The component props.
 * @param {string} props.status - The status of the tag (e.g., "Active", "Inactive").
 * @param {string} [props.customText] - Custom text to display on the tag, will override status text.
 * @param {boolean} props.enabled - Whether the tag is enabled.
 * @param {boolean} [props.visible=true] - Whether the tag should be visible.
 *
 * @returns {JSX.Element} The rendered simple small tag component.
 */
export default function SimpleSmallTag({ status, enabled, customText, visible = true }) {
    let statusText = "-";
    let statusColor = "var(--Buttons-All-Platforms-btn-action-blue)";
    let statusTextColor = "var(--text-and-icons-gray-100)";

    if (status === "Active") {
        statusText = "Active";
        statusColor = "var(--Buttons-All-Platforms-btn-action-blue)";
        statusTextColor = "var(--text-and-icons-gray-100)";
    } else if (status === "Inactive") {
        statusText = "Inactive";
        statusColor = "var(--text-and-icons-orange-500)";
        statusTextColor = "#fff";
    } else if (status === "Pending") {
        statusText = "Pending";
        statusColor = "var(--text-and-icons-orange-500)";
        statusTextColor = "#fff";
    } else if (status === "Suspended") {
        statusText = "Suspended";
        statusColor = "var(--text-and-icons-red-500)";
        statusTextColor = "#fff";
    } else if (status === "Deleted") {
        statusText = "Deleted";
        statusColor = "var(--text-and-icons-red-500)";
        statusTextColor = "#fff";
    }

    if (customText) {
        statusText = customText;
        statusColor = "#003C80";
        statusTextColor = "#fff";
    }

    return (
        <SmallTagStyled
            className="frame-313374"
            style={{ background: statusColor, display: !visible ? "none" : undefined }}
            enabled={enabled}>
            <div className="statuses">
                <div className="alert-text" style={{ color: statusTextColor }}>
                    {statusText}
                </div>
            </div>
        </SmallTagStyled>
    );
}
